import { render, staticRenderFns } from "./legendBox12.vue?vue&type=template&id=4bd0e6a2&scoped=true&"
import script from "./legendBox12.vue?vue&type=script&lang=js&"
export * from "./legendBox12.vue?vue&type=script&lang=js&"
import style0 from "./legendBox12.vue?vue&type=style&index=0&id=4bd0e6a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0e6a2",
  null
  
)

export default component.exports